import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch } from './index';

const initialState: any = {
    settings: null,
};
const COEonboardReviewSlice = createSlice({
    name: 'COEonboardReview',
    initialState,
    reducers: {
        setCOEonboardReviewSlice(state, action: PayloadAction<any>) {
            state.settings = action.payload;
        },
    },
});

export const getCOEonboardReviewSettings = (data: boolean) => {
    return async (dispatch: AppDispatch) => {
        try {
            // const response = await fetch('/onboarding-exit-reviews.json');
            // const data = await response.json();
            // await dispatch(onboardAndExitReviewSlice.actions.setOnboardAndExitReviewSlice(data));
            dispatch(COEonboardReviewSlice.actions.setCOEonboardReviewSlice(data));
        } catch (err) {
            console.log('error from COEonboardReviewSlice', err);
        }
    };
};

export default COEonboardReviewSlice.reducer;
export const { setCOEonboardReviewSlice } = COEonboardReviewSlice.actions;
